import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin,isLogin1 } from '../util/util';
import { connect } from 'react-redux';
import { checksub, checkbal } from '../Redux/Actions/Payment';
import { useSelector } from 'react-redux';
var moment = require('moment-timezone');
const param = new URLSearchParams(window.location.search);
const f = param.get('from');
const g = param.get('to');
if (f == null && g != null) {
  localStorage.setItem('redirecturl', `/pages/call?to=${g}`);
} else if (f != null && g != null) {
  localStorage.setItem('redirecturl', `/pages/call?from=${f}&to=${g}`);
}

const PrivateRoute = ({ component: Component, isPaid, checksub, subs, checkbal, ...rest }) => {
const [isValidToken, setIsValidToken] = React.useState(null); // null = loading
  const currtz = useSelector(state => state.Twilio.timezone);
  const unixTimestamp = moment.tz(currtz).valueOf() / 1000;

   React.useEffect(() => {
    checkbal();
    const validateToken = async () => {
      const valid = await isLogin1();

      console.log('valid===================from isLogin========',valid)
      setIsValidToken(valid);
    };
    validateToken();
  }, []);


  console.log('currtz=============', unixTimestamp);
  useEffect(() => {
   
    checkbal();

  
  }, [Component]);
  var subsactive = true;
 
  console.log('subs==========================', subs);

  if (subs && subs.edate == 0) {
    subsactive = false;
  }

  if (subs && subs.edate <= unixTimestamp) {
    // console.log("true")
    subsactive = false;
    console.log('subs active is', subsactive);

    console.log('subs.edate active is', subs.edate);

    console.log('process.env', process.env.REACT_APP_VERSION);

    // console.log('is login', isLogin());
  }

  console.log('is paid is ----', subs, isPaid, subsactive);

  // return (
  //   <Route
  //     {...rest}
  //     render={props =>
  //       process.env.REACT_APP_VERSION === 'true' ? (
  //         <>
  //           {isLogin() && subsactive ? (
  //             <Component {...props} />
  //           ) : isLogin() && !subsactive ? (
  //             (window.location.href = process.env.REACT_APP_MERGEASY_DOMAIN + '/pricing')
  //           ) : (

  //             (window.location.href = process.env.REACT_APP_MERGEASY_DOMAIN + '/mergecall')
       
  //           )}
  //         </>
  //       ) : process.env.REACT_APP_VERSION === 'false' ? (
  //         <>
  //           {isLogin() && isPaid && subsactive ? (
  //             <Component {...props} />
  //           ) : isLogin() && !subsactive ? (
  //             <Redirect to="/payment" />
  //           ) : isLogin() && !isPaid ? (
  //             <Redirect to="/payment" />
  //           ) : (
  //             <Redirect to="/authentication/login" />
  //           )}
  //         </>
  //       ) : (
  //         <Redirect to="/" />
  //       )
  //     }
  //   />
  // );

    if (isValidToken === null) {
    return <div>Loading...</div>; // or custom spinner
  }


return (
    <Route
      {...rest}
      render={props =>
        process.env.REACT_APP_VERSION === 'true' ? (
          <>
            {isValidToken && subsactive ? (
              <Component {...props} />
            ) : isValidToken && !subsactive ? (
              (window.location.href = process.env.REACT_APP_MERGEASY_DOMAIN + '/pricing')
            ) : (
              (window.location.href = process.env.REACT_APP_MERGEASY_DOMAIN + '/mergecall')
              // <div></div>
            )}
          </>
        ) : process.env.REACT_APP_VERSION === 'false' ? (
          <>
            {isValidToken && isPaid && subsactive ? (
              <Component {...props} />
            ) : isValidToken && !subsactive ? (
              <Redirect to="/payment" />
            ) : isValidToken && !isPaid ? (
              <Redirect to="/payment" />
            ) : (
              <Redirect to="/authentication/login" />
            )}
          </>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );

};

const mapeStateToProps = state => ({
  isPaid: state.auth.isPaid,
  isAuthenticated: state.auth.isAuthenticated,
  subs: state.auth.subs
});

export default connect(
  mapeStateToProps,
  { checksub, checkbal }
)(PrivateRoute);
